export default __webpack_public_path__ + "static/media/red.cb63fa0f.png";